export default{
    // url:"/jeecg-boot",
	url:"https://api.coolingmall.com/jeecg-boot"
	//url:"http://192.168.0.107:8081/jeecg-boot"
	//url:"http://123.60.62.211:8081/jeecg-boot"
}
